/* survivalPlotOptionsSlice.ts */

/* React-Toolkit */
import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

/* Thunks */
import { fetchStartPoints } from "src/redux/thunks/survival-analysis/survivalAnalysisThunk";

/* Constants */
import { StartPointType } from "src/shared/constants/survival-analysis/StartPoint";

/* Interfaces */
import { SurvivalAnalysisOptionsProps } from "src/shared/interfaces/insights-filter/InsightsFilterOptions";

const initialState: SurvivalAnalysisOptionsProps = {
  startPoint: {
    value: undefined,
    items: [],
    disabled: false,
  },
  showConfidenceIntervals: false,
  showNoValueEntries: false,
};

export const survivalAnalysisOptionsSlice = createSlice({
  name: "survivalPlotOptions",
  initialState: initialState,
  reducers: {
    /**
     * `undefined` is accepted so that undoing an applied agent
     * spec can restore a start point that was not yet set.
     */
    setStartPoint: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.startPoint.value = action.payload;
    },
    setShowConfidenceIntervals: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showConfidenceIntervals = action.payload;
    },
    setShowNoValueEntries: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.showNoValueEntries = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchStartPoints.fulfilled,
      (
        state,
        action: PayloadAction<StartPointType[] | undefined>
      ) => {
        if (!state.startPoint.value) {
          state.startPoint.value = action.payload?.[0];
        }
        state.startPoint.items = action.payload;
      }
    );
  },
});

/* Actions */
export const {
  setStartPoint,
  setShowConfidenceIntervals,
  setShowNoValueEntries,
} = survivalAnalysisOptionsSlice.actions;

/* Reducer */
export default survivalAnalysisOptionsSlice.reducer;
